var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AsignacionBase',{attrs:{"asignacion-global":true,"tipoModulo":"PF"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }